export { default } from './useEventCallback';


//////////////////
// WEBPACK FOOTER
// ../@mui/utils/esm/useEventCallback/index.js
// module id = 836
// module chunks = 25